<template>
    <div class="mobile--mockup">
        <div>
            <iframe :src="src" :title="title" id="activity-preview"></iframe>
        </div>
    </div>
</template>
<script>
    import EventBus from './EventBus'
    export default {
        props: ['src', 'title'],

        mounted () {
            // EventBus.$on('orderChanged', (payload) => this.refresh())
            EventBus.$on('newContentAdded', () => this.refresh())
        },

        methods: {
            refresh () {
                setTimeout(() => {
                    document.getElementById('activity-preview').contentWindow.location.reload(true)
                }, 50)
            }
        }
    }
</script>
